const returnPosition = ({ product }) => {
  const { options } = product;
    const optionsNames = ['Farbe', 'farbe', 'color', 'colour','Colour', 'Color', 'Gewicht', 'Stil', 'Wert', 'Farbe und Material', 'farbe und material', 'Color and Material', 'Color and material', 'color and material'];
    let position = options.findIndex(option => {
      const optionWithoutTags = option.replace(/<\/?tc>/g, '');
      return optionsNames.includes(optionWithoutTags);
    });
    return position;
}
const togglingClasses = ({selector,selectedColor, className }) => {
   const images = [...document.querySelectorAll(`${selector}`)];
   let indexedImages = images.map( (image,index) => { return {image,index} });
   indexedImages.forEach(({image}) => image.classList.add(`${className}`));
   let filteredImages = indexedImages.filter(({image}) => image.dataset.altName === selectedColor);
   filteredImages.map(({image}) => image.classList.remove(`${className}`));
 
 return {
   images,
   filteredImages,
 }
}
const handlingDots = ({dots, index }) =>{
  let filteredDots = dots.filter(dot => !dot.classList.contains('hidden'));
   filteredDots[index].click();
}
const filterImagesMobile = ({selectedColor}) => {
 const $slider = $(".hc-slider");

 $slider.slick('slickUnfilter');
 $slider.slick('slickFilter', `.${selectedColor}`).slick('refresh');
}
const filterImagesDesktop = ({selectedColor}) =>{
 togglingClasses({
   selector:'.product-media--root[data-media-size="desktop"] .product-media--featured',
   selectedColor,
   className: 'hidden'
 })
}
const filterLooks = ({ looksWrappers, selectedColor }) => {
    filterImagesDesktop({selectedColor})
    filterImagesMobile({selectedColor})
  let currentShopTheLook = looksWrappers.find(wrapper => wrapper.dataset.color === selectedColor);
    looksWrappers.filter(wrapper => wrapper !== currentShopTheLook).map(wrapper => wrapper.classList.add('hidden'))
    currentShopTheLook.classList.remove('hidden');
   
}
const destroySlider = slider =>{ if(slider.hasClass('slick-initialized')) slider.slick('unslick')};
const initSlider = (slider,customOptions) => {
 const prevArrow = `<button class="pswp__button hc-prev" title="Previous (arrow left)"><?xml version="1.0" ?><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z"/></g></svg></button>`;
 const nextArrow = `<button class="pswp__button hc-next" title="Next (arrow right)"><?xml version="1.0" ?><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M202.1,450a15,15,0,0,1-10.6-25.61L365.79,250.1,191.5,75.81A15,15,0,0,1,212.71,54.6l184.9,184.9a15,15,0,0,1,0,21.21l-184.9,184.9A15,15,0,0,1,202.1,450Z"/></g></svg></button>`;
 let defaultOptions = {
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows:true,
   prevArrow,
   nextArrow
 }
 let options = { ...defaultOptions, ...customOptions };
 destroySlider(slider);
 return slider.slick(options);
}